/* global Blockly */
import React from 'react';
import { hamburgerIcon } from "./index";
import HamburgerCore from "./HamburgerCore";

function defineBlock(context) {
    let blockInstance = HamburgerCore(context);
    Object.assign(blockInstance, {
        init: function () {
            this.loadOptions(false, true);
            this.appendDummyInput('WIDGET')
                .appendField('set')
                .appendField(new Blockly.FieldImage(hamburgerIcon, 30, 30, 'hamburger icon', null), 'hamburgerIcon')
                .appendField(new Blockly.FieldDropdown(this.options), this.fieldHamburgerId);

            this.appendDummyInput('PAGE')
                .appendField('for page')
                .appendField(new Blockly.FieldDropdown(context.formPages), "PAGEID");

            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Set the hamburger menu for a page.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#hamburger-menu`);
            this.setOnChange(this.changeHandler);
        }
    });
    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const hamburgerId = block.getSelectedWidgetId();
            let pageId = block.getFieldValue('PAGEID').split('<<<>>>').slice(-1);
            var code = `Snap.hamburgers.setHamburgerMenuToPage('${pageId}', ${hamburgerId});\n`;
            return code;
        }
    }
}

const SetHamburgerToPage = function (props) {
    const name = 'snap_set_hamburger_to_page';
    SetHamburgerToPage.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return props.context.formPages?.length ? 
        <block type={name}></block> : null;
}

export default SetHamburgerToPage;
